// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RepositoryMaintenanceMode {
    Disabled = 0,
    Enabled = 1
}
